import { type App, createApp, getCurrentInstance, inject } from '@/composition/vue/compositionApi'

let _storeTestingContext: App | undefined

// Like Pinia API
export const defineStore = <T>(name: string | symbol, store: () => T) => {
  return (app?: App) => {
    const currentInstance = getCurrentInstance()
    const _app = app ?? currentInstance?.appContext?.app ?? _storeTestingContext
    if (!_app) {
      throw new Error('Use the store in a setup function or provide the app instance')
    }

    const existingStore = _app.runWithContext(() => inject<T | undefined>(name, undefined))
    if (!existingStore) {
      const _store = store()
      _app.provide(name, _store)
      return _store
    }
    return existingStore
  }
}

export const deleteStore = (name: string | symbol, app?: App) => {
  const currentInstance = getCurrentInstance()
  const _app = app ?? currentInstance?.appContext?.app ?? _storeTestingContext
  if (!_app) {
    throw new Error('Use the deleteStore in a setup function or provide the app instance')
  }
  _app.provide(name, undefined)
}

export const createStoreTestingContext = () => {
  _storeTestingContext = createApp({})
}
